<template>
  <div v-if="options?.length" class="toggle-container">
    <button
      v-for="(option, index) in options"
      :key="index"
      class="toggle-btn aria-pressed:border-[1.5px] aria-pressed:border-racq-navy"
      :aria-pressed="props.context?.node?.value == option.value"
      :class="props.context?.node?.value == option.value ? 'toggle-btn-active' : ''"
      type="button"
      role="button"
      :value="option.value"
      @click="() => emitChange(option.value)"
    >
      <span class="toggle-btn-label">{{ option.label }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { IDropdownItem } from '@/interfaces';
import { computed } from 'vue';

const props = defineProps<
  Partial<{
    context: any;
  }>
>();

const options = computed(() => (props?.context?.options as IDropdownItem[]) ?? []);

function emitChange(value: string) {
  props.context?.node.input(value);
}

if (props?.context?.defaultOption && props.context?.node?.value == undefined) {
  emitChange(props?.context?.defaultOption);
}
</script>
